import Vue from 'vue';
import vuex, { Store } from 'vuex';

import itemModule from '../module/item';
import meModule from '../module/me';
import orderModule from '../module/order';
import payModule from '../module/pay';
import addressModule from '../module/address';
import cardModule from '../module/card';
import areaModule from '../module/area';
import preorderModule from '../module/preorder';
import commonModule from '../module/common';
import colleaguesBuyShareModule from '../module/colleaguesBuyShare';
import couponModule from '../module/coupon';
import balanceModule from '../module/balance';
import global_shoppingModule from '../module/global_shopping';
import direct_salesModule from '../module/direct_sales';
import welfareModule from '../module/welfare';
import idCardModule from '../module/idCard';
import installmentModule from '../module/installment';
import fenqileModule from '../module/fenqile';
import luckyMoneyModule from '../module/luckyMoney';
import giftModule from '../module/gift'
/* yeoman-template-point-1 */
import cartModule from '../module/cart';
import rechargeModule from '../module/recharge';
import sessionModule from '../module/session';
import homeModule from '../module/home';
import searchModule from '../module/search';
import topicModule from '../module/topic';
import categoryModule from '../module/category';
import enterpriseModule from '../module/enterprise';
import rcModule from '../module/rc';
import activityModule from '../module/activity';
import refundModule from '../module/refund';

import recomendModule from '../module/recommend';
import buyerModule from '../module/buyer';
import wechatModule from '../module/wechat';

import groupModule from '../module/group';
import serviceModule from '../module/service';
import cityModule from '../module/city';
import helpModule from '../module/help';

/* 企业专区等活动业务独立模块 */
import businessModule from '../module/business';
import examineModule from '../module/examine';

/* 商品模板业务 */
import productTemplateModule from '../module/product_template';

/* 券码 */
import Electronic from "./modules/electronic/electronic.js"

// 兑换记录
import exchangeRecordModule from '../module/exchange_record';

const myPlugin = (store) => {
  store.subscribe((mutation, state) => {});
};

Vue.use(vuex);

export default new Store({
  state: {
    errorAppear: 0,
    errorMsg: '',
  },
  mutations: {
    rootApperError(state, msg) {
      state.errorAppear += 1;
      state.errorMsg = msg;
    },
  },
  plugins: [myPlugin],
  modules: {
    Electronics:Electronic,
    item: itemModule,
    me: meModule,
    order: orderModule,
    pay: payModule,
    address: addressModule,
    card: cardModule,
    area: areaModule,
    preorder: preorderModule,
    common: commonModule,
    colleaguesBuyShare: colleaguesBuyShareModule,
    coupon: couponModule,
    balance: balanceModule,
    global_shopping: global_shoppingModule,
    direct_sales: direct_salesModule,
    welfare: welfareModule,
    cart: cartModule,
    recharge: rechargeModule,
    session: sessionModule,
    home: homeModule,
    search: searchModule,
    topic: topicModule,
    category: categoryModule,
    enterprise: enterpriseModule,
    rc: rcModule,
    activity: activityModule,
    refund: refundModule,
    recommend: recomendModule,
    buyer: buyerModule,
    wechat: wechatModule,
    group: groupModule,
    idCard: idCardModule,
    installment: installmentModule,
    service: serviceModule,
    fenqile: fenqileModule,
    city: cityModule,
    luckyMoney: luckyMoneyModule,
    business: businessModule,
    examine: examineModule,
    gift: giftModule,
    help: helpModule,
    productTemplate: productTemplateModule,
    exchangeRecord: exchangeRecordModule,
  },
  strict: process.env.NODE_ENV !== 'production',
});
